import "./App.css";
import AllRoutes from "./routes/AllRoutes";
import ScrollToTop from "./utilities/functions/ScrollToTop";
import { Box, Center } from "@chakra-ui/react";
import { Suspense } from "react";
import MainNavigation from "./utilities/components/navigation/MainNavigation";
import { HashLoader } from "react-spinners";
import Footer from "./utilities/components/footer/Footer";

function App() {
  let routes;

  routes = <AllRoutes />;

  return (
    <>
      <ScrollToTop />
      <Box
        // fontFamily="Roboto"
        // overflow={"auto"}
        bg="#000"
      >
        <MainNavigation />
        <main>
          <Suspense
            fallback={
              <Center h="100vh">
                <HashLoader size={80} color="#5E3AEE" />
              </Center>
            }
          >
            {routes}
          </Suspense>
        </main>
        <Footer />
      </Box>
    </>
  );
}

export default App;
